module.exports = "/assets/data/2e72a9410267e5b20db00101e0c28298-DG5.data.json";